import { useMemo } from 'react';
import { Badge } from '../ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { STATUS_STYLES } from '../../utils/bankConstants';

const KpiDetailPopup = ({ kpiPopup, kpiLoading, onClose }) => {
  const accountTypeCounts = useMemo(() => {
    if (!kpiPopup?.banks) return [];
    return Object.entries(
      kpiPopup.banks.reduce((acc, b) => { const t = b.accountType || 'Savings'; acc[t] = (acc[t] || 0) + 1; return acc; }, {})
    ).filter(([, c]) => c > 0).sort((a, b) => b[1] - a[1]);
  }, [kpiPopup?.banks]);

  return (
    <Dialog open={!!kpiPopup} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{kpiPopup?.title} ({kpiPopup?.banks?.length || 0})</DialogTitle>
        </DialogHeader>
        {kpiLoading ? (
          <div className="py-8 text-center text-slate-500">Loading...</div>
        ) : kpiPopup?.banks?.length > 0 ? (
          <div className="space-y-3">
            <div className="flex gap-2 flex-wrap">
              {accountTypeCounts.map(([type, count]) => (
                <Badge key={type} variant="outline" className="text-xs px-2 py-1">{type}: <strong className="ml-1">{count}</strong></Badge>
              ))}
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b bg-slate-50">
                    <th className="text-left p-2 text-xs font-semibold">Company</th>
                    <th className="text-left p-2 text-xs font-semibold">Bank</th>
                    <th className="text-left p-2 text-xs font-semibold">Vendor</th>
                    <th className="text-left p-2 text-xs font-semibold">Account</th>
                    <th className="text-left p-2 text-xs font-semibold">Type</th>
                    <th className="text-left p-2 text-xs font-semibold">Branch</th>
                    <th className="text-left p-2 text-xs font-semibold">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {kpiPopup.banks.map(bank => (
                    <tr key={bank.id} className="border-b hover:bg-slate-50">
                      <td className="p-2 font-medium">{bank.companyName || '-'}</td>
                      <td className="p-2">{bank.bankName}</td>
                      <td className="p-2"><Badge variant="outline" className="text-xs">{bank.vendorName}</Badge></td>
                      <td className="p-2 font-mono text-xs">{bank.accountNumber}</td>
                      <td className="p-2 text-xs">{bank.accountType || 'Savings'}</td>
                      <td className="p-2 text-xs">{bank.assignedPartnerName || '-'}</td>
                      <td className="p-2"><Badge className={STATUS_STYLES[bank.status] || 'bg-slate-100 text-slate-800'}>{bank.status}</Badge></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="py-8 text-center text-slate-400">No items found</div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default KpiDetailPopup;
